import React from 'react';
import styled from 'styled-components';
import { useImagesContext } from '../../../contexts/ImagesContext';

const SoulNumber = ({ number, fontHeight, top }) => {
  const { images } = useImagesContext();
  const imageTagList = [];
  let dividedResult = number;
  let key = 1;
  while (dividedResult > 0) {
    const oneDigitNumber = dividedResult % 10;
    imageTagList.push(
      <img
        style={{ height: fontHeight, position: 'relative' }}
        key={key}
        src={images[`play-soul-${oneDigitNumber}.png`]}
        alt=""
      />
    );
    dividedResult = Math.floor(dividedResult / 10);
    key += 1;
  }
  return (
    // <div style={{ display: 'flex', justifyContent: 'center', top: top, left: left, position: 'absolute' }}>
    <NumberBlock $top={top} $height={fontHeight}>
      {imageTagList.reverse()}
    </NumberBlock>
    // </div>
  );
};

const NumberBlock = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  top: ${(props) => props.$top};
  height: ${(props) => props.$height};
  width: 100%;
`;

export default SoulNumber;
